module.exports = __webpack_public_path__ + "static/img/Export.16eff5ab.svg";